<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <v-card-title> {{ title }} </v-card-title>
            <v-divider class="mx-3"></v-divider>

            <v-card-item>
                <v-form class="override_content_flex" @submit.prevent="save()">
                    <div class="col-flex-6">
                        <v-text-field  
                            label="Nombre(s)" 
                            v-model="formGroup.data.nombre"
                            :rules="formGroup.rules.nombre"
                            variant="outlined"
                            class="w-100">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field  
                            label="Apellido(s)" 
                            v-model="formGroup.data.apellido"
                            :rules="formGroup.rules.apellido"
                            variant="outlined"
                            class="w-100">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-select
                            label="Despachos"
                            v-model="formGroup.data.despachos"
                            :rules="formGroup.rules.despachos"
                            variant="outlined"
                            :items="arrDispatch"
                            item-title="nombre"
                            item-value="nombre_bd"
                            @update:model-value="getGroupByProfile()"
                            class="w-100">
                        </v-select>
                    </div>
                    <div class="col-flex-6">
                        <v-select
                            label="Tipo de Usuario" 
                            v-model="formGroup.data.tipoUsuario"
                            :rules="formGroup.rules.tipoUsuario"
                            variant="outlined"
                            :items="arrDataTypeUser"
                            item-title="value"
                            item-value="key"
                            class="w-100">
                        </v-select>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field  
                            label="Usuario" 
                            v-model="formGroup.data.usuario"
                            :rules="formGroup.rules.usuario"
                            variant="outlined"
                            class="w-100">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <!-- :rules="formGroup.rules.grupo" -->
                        <v-select
                            label="Grupo" 
                            v-model="formGroup.data.grupo"
                            variant="outlined"
                            :items="arrGroup"
                            item-title="nombre"
                            item-value="id_grupo"
                            class="w-100">
                        </v-select>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field  
                            label="Correo Electrónico" 
                            v-model="formGroup.data.correoElectronico"
                            :rules="formGroup.rules.correoElectronico"
                            variant="outlined"
                            class="w-100">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field  
                            label="Contraseña" 
                            v-model="formGroup.data.contrasena"
                            :rules="formGroup.rules.contrasena"
                            variant="outlined"
                            class="w-100"
                            :type="visiblePassword1 ? 'text' : 'password'"
                            @click:append-inner="visiblePassword1 = !visiblePassword1"
                            :append-inner-icon="visiblePassword1 ? 'mdi-eye-off' : 'mdi-eye'">

                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <v-text-field  
                            label="Repetir contraseña" 
                            v-model="formGroup.data.repetirContrasena"
                            :rules="formGroup.rules.repetirContrasena"
                            variant="outlined"
                            class="w-100"
                            :type="visiblePassword2 ? 'text' : 'password'"
                            @click:append-inner="visiblePassword2 = !visiblePassword2"
                            :append-inner-icon="visiblePassword2 ? 'mdi-eye-off' : 'mdi-eye'">
                        </v-text-field>
                    </div>
                    <div class="col-flex-6">
                        <!-- :rules="formGroup.rules.user_scl" -->
                        <v-text-field  
                            label="Usuario SCL" 
                            v-model="formGroup.data.user_scl"
                            variant="outlined"
                            class="w-100">
                        </v-text-field>
                    </div>
                    <div style="width: 100%; display: flex; flex-direction: row-reverse; padding: 16px 16px;">
                        <v-btn 
                            v-if="permission.addUser"
                            color="indigo-darken-3"
                            prepend-icon="mdi-content-save"
                            :loading="isLoadingForm"
                            type="submit"
                            text="Guardar"
                            class="text-none"
                            :disabled="!validateForm()"
                        ></v-btn>

                        <v-btn
                            color="grey-darken-3"
                            prepend-icon="mdi-arrow-left"
                            @click="$router.push('/SGCCV/user-management')"
                            text="Regresar"
                            class="text-none mr-2"
                        ></v-btn>
                    </div>
                </v-form>
            </v-card-item>
        </v-card>
        <SnackbarComponent :value="snackbarData"/>
    </div>
</template>

<script>
import { EncryptService } from '@/services/EncryptService'
import { DispatchService } from '@/services/DispatchService'
import { GroupService } from '@/services/GroupService'
import { UserManagementService } from '@/services/UserManagementService'
import SnackbarComponent from '@/components/Snackbar.vue'
export default {
    name: 'LoginView',
    props: {
        msg: String
    },
    components: {
        SnackbarComponent,
    },
    data() {
        return {
            type: '',
            idUser: '',
            title: '',
            formGroup: {
                data: {
                    nombre: '',
                    apellido: '',
                    despachos: null,
                    tipoUsuario: null,
                    usuario: '',
                    grupo: null,
                    correoElectronico: '',
                    contrasena: '',
                    repetirContrasena: '',
                    user_scl: '',
                },
                rules: {
                    nombre: [
                        value => {
                            if (value) {
                                return true
                            }
                            return `El campo Nombre(s) es obligatorio`
                        }
                    ],
                    apellido: [
                        value => {
                            if (value) {
                                return true
                            }
                            return `El campo Apellido(s) es obligatorio`
                        }
                    ],
                    despachos: [
                        value => {
                            if (value) {
                                return true
                            }
                            return `El campo Despachos es obligatorio`
                        }
                    ],
                    tipoUsuario: [
                        value => {
                            if (value) {
                                return true
                            }
                            return `El campo Tipo de Usuario es obligatorio`
                        }
                    ],
                    usuario: [
                        value => {
                            if (value) {
                                return true
                            }
                            return `El campo Usuario es obligatorio`
                        }
                    ],
                    grupo: [
                        /* value => {
                            if (value) {
                                return true
                            }
                            return `El campo Grupo es obligatorio`
                        } */
                    ],
                    correoElectronico: [
                        value => {
                            if (value) {
                                return true
                            }
                            return `El campo Correo Electrónico es obligatorio`
                        }
                    ],
                    contrasena: [
                        value => {
                            
                            if (value === '') {
                                return `El campo contraseña es obligatorio`
                            }
                            
                            if (value.length < 8) {
                                return `El campo contraseña debe tener al menos 8 caracteres.`
                            }
                            
                            if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/+-])[A-Za-z\d$@$!%*?&]{8,}$/.test(value)) {
                                return 'La contraseña debe tener mínimo 8 caracteres, con al menos: una mayúscula, una minúscula, un número y un carácter especial ($ @ ! % * ? &). Caduca en 45 días.';
                            }

                            return true
                        }
                    ],
                    repetirContrasena: [
                        value => {
                            
                            if (value === '') {
                                return `El campo Repetir contraseña es obligatorio`
                            }
                            
                            if (value.length < 8) {
                                return `El campo Repetir Contraseña debe tener al menos 8 caracteres`
                            }
                            
                            if (value !== this.formGroup.data.contrasena) {
                                return 'Las contraseñas no coinciden';
                            }
                            
                            if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&/+-])[A-Za-z\d$@$!%*?&]{8,}$/.test(value)) {
                                return 'La contraseña debe tener mínimo 8 caracteres, con al menos: una mayúscula, una minúscula, un número y un carácter especial ($ @ ! % * ? &). Caduca en 45 días.';
                            }
                            
                            return true
                        },
                    ],
                    user_scl: [
                        value => {
                            if (value) {
                                return true
                            }
                            return `El campo Usuario SCL es obligatorio`
                        }
                    ],
                }
            },
            arrDataTypeUser: [
                {
                    key: 'Superadministrador',
                    value: 'Super Administrador',
                },
                {
                    key: 'Administrador',
                    value: 'Administrador',
                },
                {
                    key: 'Supervisor',
                    value: 'Supervisor',
                },
                {
                    key: 'Gestor',
                    value: 'Gestor',
                },
                {
                    key: 'Colaborador',
                    value: 'Gestor de Campo',
                },
                {
                    key: 'Multiadmin',
                    value: 'Multi Administrador',
                }
            ],
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            arrDispatch: [],
            arrGroup: [],
            isLoading: false,
            isLoadingForm: false,
            visiblePassword1: false,
            visiblePassword2: false,
            permission: {
                addUser: false,
            }
        }
    },
    async created() {

        const ENC_PERMISOS = localStorage.getItem('PERMISOS')
        const STR_PERMISOS = atob(ENC_PERMISOS)
        const ARR_PERMISOS = JSON.parse(STR_PERMISOS)
        const PERMISSION = ARR_PERMISOS.find((permission) => permission.modulo === 'M05GEUS')
        for (const element of PERMISSION.endpoints) {
            if (element.nombre === 'M05F01AGUS' && element.permiso === true) {
                this.permission.addUser = true
            }
        }
            
        let params = this.$route.params.form
        let strParams = await EncryptService.decrypt(params)
        let form = JSON.parse(strParams);
        this.type = form.type
        this.idUser = form.idUser

        if (this.type === 'R') {
            this.title = 'Registro de usuario'
        } else if (this.type === 'M' && this.idUser !== undefined && this.idUser !== '') {
            this.title = 'Modificación de usuario'

        } else {
            window.history.back();
        }
    },
    async mounted() {
        await this.getDispatch()
        //await this.getGroupByProfile()
    },
    methods: {
        getDispatch: async function () {
            await DispatchService.getDispatch().then(
                (responseData) => {
                    if (!responseData.error) {
                        this.arrDispatch = responseData.response
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        getGroupByProfile: async function () {
            const TYPE = localStorage.getItem('TIPO')
            const NOMBRE_BD = this.formGroup.data.despachos;
            if (NOMBRE_BD !== null) {
                await GroupService.getGroupByProfile(TYPE, NOMBRE_BD).then(
                    (responseData) => {
                        if (!responseData.error) {

                            let arrGroup = [{
                                id_grupo: null,
                                nombre: '--Ninguno--'
                            }];
                            arrGroup = arrGroup.concat(responseData.response)
                            this.arrGroup = arrGroup;
                        } else {
                            this.snackbarData.description = responseData.msg
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            }
        },
        save: async function () {

            if (!this.permission.addUser) {
                this.snackbarData.description = `No tienes permisos para agregar un usuario`
                this.snackbarData.openSnackbar = true
                return;
            }

            this.isLoadingForm = true

            let nombre = this.formGroup.data.nombre
            nombre = nombre.toString().trim()

            let apellido = this.formGroup.data.apellido
            apellido = apellido.toString().trim()

            let despachos = this.formGroup.data.despachos
            despachos = despachos.toString().trim()
            despachos = await EncryptService.encrypt(despachos)

            let tipoUsuario = this.formGroup.data.tipoUsuario
            tipoUsuario = tipoUsuario.toString().trim()
            tipoUsuario = await EncryptService.encrypt(tipoUsuario)

            let usuario = this.formGroup.data.usuario
            usuario = usuario.toString().trim()
            usuario = await EncryptService.encrypt(usuario)

            let correoElectronico = this.formGroup.data.correoElectronico
            correoElectronico = correoElectronico.toString().trim()
            correoElectronico = await EncryptService.encrypt(correoElectronico)

            let contrasena = this.formGroup.data.contrasena
            contrasena = contrasena.toString().trim()
            contrasena = await EncryptService.encrypt(contrasena)

            let grupo = this.formGroup.data.grupo
            if (grupo !== null && grupo !== undefined) {
                grupo = grupo.toString().trim()
            }else{
                grupo = ''
            }
        
            let user_scl = this.formGroup.data.user_scl
            user_scl = user_scl.toString().trim()
            user_scl = await EncryptService.encrypt(user_scl)

            const formData = new FormData();
            formData.append("nombre", nombre);
            formData.append("apellidos", apellido);
            formData.append("despacho", despachos);
            formData.append("tipo", tipoUsuario);
            formData.append("username", usuario);
            formData.append("email", correoElectronico);
            formData.append("password", contrasena);
            formData.append("grupo", grupo);
            formData.append("user_scl", user_scl);

            await UserManagementService.registerUser(formData).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.snackbarData.description = `¡Registro Exitoso!`
                        this.snackbarData.openSnackbar = true
                        this.$router.push('/SGCCV/user-management')
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                        this.isLoadingForm = false;
                    }
                }
            )
        },
        validateForm: function () {
            const NOMBRE = this.formGroup.data.nombre
            if (NOMBRE === null || NOMBRE === undefined || NOMBRE === '') {
                return false
            }
            const APELLIDO = this.formGroup.data.apellido
            if (APELLIDO === null || APELLIDO === undefined || APELLIDO === '') {
                return false
            }
            const DESPACHOS = this.formGroup.data.despachos
            if (DESPACHOS === null || DESPACHOS === undefined || DESPACHOS === '') {
                return false
            }
            const TIPOUSUARIO = this.formGroup.data.tipoUsuario
            if (TIPOUSUARIO === null || TIPOUSUARIO === undefined || TIPOUSUARIO === '') {
                return false
            }
            const USUARIO = this.formGroup.data.usuario
            if (USUARIO === null || USUARIO === undefined || USUARIO === '') {
                return false
            }
            // const GRUPO = this.formGroup.data.grupo
            const CORREOELECTRONICO = this.formGroup.data.correoElectronico
            if (CORREOELECTRONICO === null || CORREOELECTRONICO === undefined || CORREOELECTRONICO === '') {
                return false
            }
            const CONTRASENA = this.formGroup.data.contrasena
            if (CONTRASENA === null || CONTRASENA === undefined || CONTRASENA === '') {
                return false
            }
            const REPETIRCONTRASENA = this.formGroup.data.repetirContrasena
            if (REPETIRCONTRASENA === null || REPETIRCONTRASENA === undefined || REPETIRCONTRASENA === '') {
                return false
            }
            
            if (CONTRASENA !== REPETIRCONTRASENA) {
                return false
            }
            return true

        }
    }
}
</script>

<style scoped>
</style>